//Paso 1

import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getNextQuestionService,
  getQuizPhaseService,
  getVideoTutorialInicioQuizService,
  sendAnswerService,
  startQuizSessionService,
} from "../../services/quiz/quiz.service";

export const startQuizThunk = createAsyncThunk(
  "quiz/start",
  async (_, { rejectWithValue }) => {
    try {
      // Aquí iría la lógica para iniciar el quiz, por ejemplo, una llamada a la API
      const response = await startQuizSessionService();

      const sessionId = response.data.id;

      localStorage.setItem("quiz_session_id", sessionId);

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al iniciar el quiz",
      );
    }
  },
);

//Paso2
export const getNextQuestionThunk = createAsyncThunk(
  "quiz/nextQuestion",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { sessionId } = getState().quiz;
      const response = await getNextQuestionService(sessionId);
      return response;
    } catch (error) {
      const message = error.response?.data?.message;

      // Detectar quiz completado aunque venga como 400
      if (message === "La evaluación ya fue completada") {
        return rejectWithValue("QUIZ_COMPLETED");
      }

      return rejectWithValue(
        message || "Error al obtener la siguiente pregunta",
      );
    }
  },
);

export const sendAnswerThunk = createAsyncThunk(
  "quiz/sendAnswer",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await sendAnswerService(payload);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al enviar la respuesta",
      );
    }
  },
);

export const getQuizPhaseThunk = createAsyncThunk(
  "quiz/getPhase",
  async (_, { rejectWithValue }) => {
    try {
      return await getQuizPhaseService();
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error obteniendo fase",
      );
    }
  },
);

export const getVideoTutorialInicioQuizThunk = createAsyncThunk(
  "quiz/getVideoTutorial",
  async (_, { rejectWithValue }) => {
    try {
      return await getVideoTutorialInicioQuizService();
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error obteniendo video tutorial",
      );
    }
  },
);
